import validate from 'lib/utils/validationRules';
import { events as alert } from '@/plugins/capusta_alert/events';

export default async function dealRefund({ to, next, store }) {
  const { query } = to;

  if (!validate.isObjectWithFields(query, ['publicId'])) {
    return next({ name: 'cabinet' });
  }

  if (validate.isEmptyString(query.publicId)) {
    return next({ name: 'cabinet' });
  }

  try {
    await store.dispatch('transaction/fetchTransaction', query.publicId);

    if (store.getters['transaction/isRefundStatus']) {
      return next({
        name: 'cabinet',
        query: { public_id: query.publicId },
      });
    }

    await store.dispatch('refund/refundCommission', query.publicId);
    store.commit('refund/SET_VISIBLE', true);
  } catch (error) {
    console.error(error);

    alert.$emit('show', {
      type: 'warning',
      text: 'data.not.loaded',
    });
  }

  return next({
    name: 'cabinet',
    query: { public_id: query.publicId },
  });
}
